import { Select } from '@approvalmax/ui/src/components';
import { memo, useCallback } from 'react';

import { FilterType } from '../../../../data/filters';
import { messages } from './FilterUserList.messages';
import { FilterUserListProps } from './FilterUserList.types';

export const FilterUserList = memo<FilterUserListProps>((props) => {
    const { options, filter, onFilterChange } = props;

    const handleChange = useCallback(
        (values: string[]) => {
            onFilterChange({
                ...filter,
                ...(filter.type === FilterType.UserList ? { emails: values } : { ids: values }),
            });
        },
        [filter, onFilterChange]
    );

    return (
        <Select
            multiple
            value={filter.type === FilterType.UserList ? filter.emails : filter.ids}
            size='small'
            itemIdKey='id'
            itemNameKey='displayName'
            items={options}
            onChange={handleChange}
            placeholder={messages.placeholder}
            autocomplete
        />
    );
});

FilterUserList.displayName = 'FilterUserList';
